import { render, staticRenderFns } from "./porc-aprobacion-lineas-poliza.vue?vue&type=template&id=2e1c2f1c&"
import script from "./porc-aprobacion-lineas-poliza.vue?vue&type=script&lang=js&"
export * from "./porc-aprobacion-lineas-poliza.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./porc-aprobacion-lineas-poliza.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports